/** Passwort-Regeln — Gegenstück zu app/core/security.py (MIN_PASSWORD_LENGTH).
 *  Beide Werte müssen übereinstimmen; der Server ist die verbindliche Instanz. */

export const MIN_PASSWORD_LENGTH = 12;

export const PASSWORD_HINT = `Mindestens ${MIN_PASSWORD_LENGTH} Zeichen.`;

/** Fehlermeldung für ein zu kurzes Passwort, sonst null. */
export function passwordError(password: string): string | null {
  if (password.length > 0 && password.length < MIN_PASSWORD_LENGTH) {
    return `Das Passwort ist zu kurz (mindestens ${MIN_PASSWORD_LENGTH} Zeichen).`;
  }
  return null;
}
